import React, { useState } from "react";
import NavBar from "../Components/NavBar";
import { useDispatch, useSelector } from "react-redux";
import InputProfile from "../Components/Form/InputProfile";
import { useForm } from "react-hook-form";
import { firestore } from "../Firebase/config";
import {  doc, updateDoc } from "firebase/firestore";
import { login } from "../Features/userSlice";

export default function Profile() {
  const user = useSelector((state) => state.user.user);
  const [isEdit, setIsEdit] = useState();
  const dispatch = useDispatch();

  const { register, handleSubmit } = useForm({
    defaultValues: {
      email: user.email,
      username: user?.username,
      phone: user?.phone,
    },
  });

  // * Updating user Profile
  const saveProfile = async (data) => {
    try {
      const docRef = await doc(firestore, "users", user.docId);

      await updateDoc(docRef, {
        email: data.email,
        username: data.username,
        phone: data.phone,
      });
      dispatch(login({ ...data, docId :  user.docId }));
      setIsEdit(false);
    } catch (error) {
      // console.log(error);
      setIsEdit(false);
    }
  };

  return (
    <>
      <NavBar />

      <h2 className="text-center text-3xl m-10">Profile</h2>
      <form
        className="sm:max-w-2xl max-w-sm mx-auto mb-20"
        onSubmit={handleSubmit(saveProfile)}
      >
        <InputProfile
          label="User Name"
          type="text"
          disabled={!isEdit}
          {...register("username", { required: true })}
        />
        <InputProfile
          label="Email"
          type="email"
          disabled={!isEdit}
          {...register("email", { required: true })}
        />
        <InputProfile
          label="Phone"
          type="number"
          disabled={!isEdit}
          {...register("phone", { required: true })}
        />

        <div className="flex m-3 justify-center">
          {isEdit ? (
            <>
              <button
                type="submit"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              >
                {" "}
                Save{" "}
              </button>
              <button
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  setIsEdit(false);
                }}
                className="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-lg px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
              >
                Cancel
              </button>
            </>
          ) : (
            <button
              onClick={(e) => {
                e.preventDefault();
                setIsEdit(true);
              }}
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
            >
              {" "}
              Edit{" "}
            </button>
          )}
        </div>
      </form>
    </>
  );
}
